import useQuery from '../../../../hooks/useQuery';

import './AccessDenied';

export default function AccessDenied() {
  const query = useQuery();

  return (
    <div id="accessdenied">
      <img
        src="https://www.baltlife.com/img/logo@2x.png"
        alt="Baltimore Life Insurance Logo"
      />
      Access Denied
      {query.get('description')}
    </div>
  );
}
